import { render, staticRenderFns } from "./select-record-type.vue?vue&type=template&id=10addbb4&"
import script from "./select-record-type.vue?vue&type=script&lang=js&"
export * from "./select-record-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports